/**
 * Created by tofael on 3/23/17.
 */
import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import api from '../utility/api';
import List from '../screens/list/';
import {asyncStart, asyncEnd} from '../actions/application';

class DoctorRequests extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      requests: [],
    };
  }

  componentDidMount() {
    this.props.dispatch(asyncStart());
    api.getPendingApplications()
      .then(resp => {
        this.props.dispatch(asyncEnd());
        this.setState({requests: resp});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
      });
  }

  render() {

    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        show: false,
      },
      {
        id: 'userName',
        Header: 'Name',
        accessor: d => d.user.name
      },
      {
        Header: 'Doctor Reg No',
        accessor: 'reg_no'
      },
      {
        id: 'userPhone',
        Header: 'Phone',
        accessor: d => d.user.phone
      },
      {
        id: 'userEmail',
        Header: 'Email',
        accessor: d => d.user.email
      }
    ];

    let {requests} = this.state;
    let {isLoading} = this.props.application;
    let reactTableProps = {
      data: requests,
      columns,
      isLoading,
      noDataText: 'No pending application.',
      getTdProps: (state, rowInfo) => {
        return {
          onClick: e => {
            if (rowInfo)
              hashHistory.push('/doctor/' + rowInfo.row.id)
          }
        }
      }
    };

    return (
      <List
        title="Pending Doctor Applications"
        reactTableProps={reactTableProps}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(DoctorRequests);


// WEBPACK FOOTER //
// ./src/containers/doctor-applications.js